import { gql } from '@apollo/client';

export default gql`
  mutation updateHritem(
    $_id: String
    $time: Date
    $isWorking: Boolean
    $isAbsent: Boolean
    $isShift1: Boolean
    $isShift2: Boolean
    $bonosvalue: Float
    $bonosqty: Float
    $bonos: Float
    $overtimevalue: Float
    $overtimeqty: Float
    $overtime: Float
    $deductionvalue: Float
    $deductionqty: Float
    $deduction: Float
    $desc: String
    $contractId: String
    $contractName: String
    $contractNameAr: String
    $departmentId: String
    $departmentName: String
    $departmentNameAr: String
    $employeeId: String
    $employeeName: String
    $employeeNameAr: String
    $userId: String
    $note: String
  ) {
    updateHritem(
      _id: $_id
      time: $time
      isWorking: $isWorking
      isAbsent: $isAbsent
      isShift1: $isShift1
      isShift2: $isShift2
      bonosvalue: $bonosvalue
      bonosqty: $bonosqty
      bonos: $bonos
      overtimevalue: $overtimevalue
      overtimeqty: $overtimeqty
      overtime: $overtime
      deductionvalue: $deductionvalue
      deductionqty: $deductionqty
      deduction: $deduction
      desc: $desc
      contractId: $contractId
      contractName: $contractName
      contractNameAr: $contractNameAr
      departmentId: $departmentId
      departmentName: $departmentName
      departmentNameAr: $departmentNameAr
      employeeId: $employeeId
      employeeName: $employeeName
      employeeNameAr: $employeeNameAr
      userId: $userId
      note: $note
    ) {
      ok
      message
      data
      error
    }
  }
`;
